import { useEffect, useState } from 'react'

import { cloneDeep, sortBy, find } from 'lodash'
import { useNavigate } from 'react-router-dom'

import { useUser, useLang, useListBoards } from '../utils/hooks'

import Footer from '../components/Footer'
import PageSelect from '../components/PageSelect'
import BoardList from '../components/BoardList'
import BoardModify from '../components/BoardModify'
import RemoveBoardSailModal from '../components/RemoveBoardSailModal'

import { langBoards } from '../assets/langBoards'
import { boardsNumberOfItemsPerPage, textClass } from '../assets/colors'
import { useRef } from 'react'

const Boards = () => {
  const SORTS = {
    NONE: (list) => list,
    BRAND_SORT: (list) => sortBy(list, 'brand'),
    YEAR_SORT: (list) => sortBy(list, 'year'),
    VOLUME_SORT: (list) => sortBy(list, 'volume'),
  }

  const firstDiv = useRef(null)

  const { user } = useUser()
  const { lang } = useLang()
  const { listBoards, setListBoards } = useListBoards()
  const [board, setBoard] = useState()
  const [okBoard, setOkBoard] = useState()
  const [showModify, setShowModify] = useState(false)
  const [modifyType, setModifyType] = useState('')

  const [removeModal, setRemoveModal] = useState({
    removeTitle: '',
    removeModalIsOpen: false,
  })

  const [deleteAllowed, setDeleteAllowed] = useState(false)

  const [isDeleting, setIsDeleting] = useState(false)

  const choosenLang = lang === 'eng' ? langBoards.eng : langBoards.fr

  const demoUserName = process.env.REACT_APP_DEMO_USERNAME

  let navigateTo = useNavigate()

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    if (user.userId === -1) {
      if (listBoards.data.length === 0) {
        const localUserId = localStorage.getItem('wsurf_userId')
        if (!localUserId || Number(localUserId) === -1) navigateTo('/login')
        else navigateTo('/sessions/')
      }
    }
  }, [])

  useEffect(() => {
    let tempBoard = find(listBoards.data, (board) => board.bg === 'selected')
    if (tempBoard === undefined) {
      tempBoard = {
        brand: '',
        model: '',
        year: '',
        volume: '',
        active: true,
        _id: '',
        userId: '',
      }
    }
    const tempOkBoard = {
      brandOk: tempBoard.brand !== '',
      modelOk: tempBoard.model !== '',
      yearOk: tempBoard.year !== '',
      volumeOk: tempBoard.volume !== '',
    }

    setBoard(tempBoard)
    setOkBoard(tempOkBoard)
  }, [])

  //handles
  const handleSortBoards = (column_type) => {
    const sort_order =
      column_type === listBoards.sortOrder.sortType
        ? !listBoards.sortOrder.isReverse
        : true
    let sort_type = column_type
    const sortFunction = SORTS[sort_type]
    const temp = sort_order
      ? sortFunction(Array.from(listBoards.data)).reverse()
      : sortFunction(Array.from(listBoards.data))
    setListBoards({
      type: 'SORT_CHANGED',
      payload: {
        list: temp,
        sort: { sortType: column_type, isReverse: sort_order },
      },
    })
  }

  const handleSelectNewItem = (item) => {
    if (showModify === true) return
    const temp = cloneDeep(listBoards.data)
    const old_index = temp
      .map(function (e) {
        return e.bg
      })
      .indexOf('selected')
    const new_index = temp
      .map(function (e) {
        return e._id
      })
      .indexOf(item._id)

    if (old_index !== -1) {
      temp[old_index].bg = ''
    }

    if (old_index !== new_index) {
      temp[new_index].bg = 'selected'
      setBoard(item)
      setOkBoard({ brandOk: true, modelOk: true, yearOk: true, volumeOk: true })
    } else {
      setBoard({
        brand: '',
        model: '',
        year: '',
        volume: '',
        active: false,
      })
      setOkBoard({
        brandOk: false,
        modelOk: false,
        yearOk: false,
        volumeOk: false,
      })
      setShowModify(false)
    }
    setListBoards({ type: 'NEW_ITEM_SELECTED', payload: temp })
  }

  const handleRemove = () => {
    const boardId = board._id

    const url = '/api/rig/getNbRigsForBoard'
    const data = { boardId }

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((nb) => {
          if (nb > 0) {
            setDeleteAllowed(false)
            setIsDeleting(true)
          } else {
            setDeleteAllowed(true)
            setIsDeleting(true)
            setRemoveModal({
              removeTitle:
                board.brand +
                ' ' +
                board.model +
                ' ' +
                board.volume +
                ' ' +
                board.year,
              removeModalIsOpen: true,
            })
          }
        })
      })
      .catch((error) => {
        console.log('error getting nb of rigs for board ' + boardId, error)
      })
  }

  const handleDoDeleteBoard = () => {
    const boardId = board._id
    const url = '/api/board/deleteOneBoard'
    const data = { boardId }

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log('board ' + boardId + ' supprimée')
        const temp_data = cloneDeep(listBoards.initialData)
        const temp_index = temp_data.findIndex((element) => {
          return element._id === boardId
        })
        temp_data.splice(temp_index, 1)

        setListBoards({ type: 'REMOVE_BOARD', payload: temp_data })
        setIsDeleting(false)
        setDeleteAllowed(false)
        handleCloseRemoveModal()
      })
      .catch((error) => {
        console.log('delete session error', error)
      })
  }

  const handleCloseRemoveModal = () => {
    setRemoveModal({
      removeTitle: '',
      removeModalIsOpen: false,
    })
    setIsDeleting(false)
    setDeleteAllowed(false)
  }

  const handleCloseNotification = () => {
    setIsDeleting(false)
    setDeleteAllowed(false)
  }

  const handleModify = () => {
    setModifyType('update')
    setShowModify(true)
  }

  const handleCancel = () => {
    setShowModify(false)
  }

  const handleSave = () => {
    let url
    let data = {
      board: {
        brand: board.brand,
        model: board.model,
        year: board.year,
        volume: board.volume,
        active: board.active,
        userId: user.userId,
      },
    }

    switch (modifyType) {
      case 'add':
        url = '/api/board/createBoard'
        break
      case 'update':
        url = '/api/board/updateBoard'
        data.bordId = board._id
        break
      default:
    }

    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]

    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((dataBoard) => {
          let temp
          switch (modifyType) {
            case 'add':
              temp = cloneDeep(listBoards).data
              temp.push(dataBoard)
              setListBoards({ type: 'ADD_BOARD', payload: temp })
              setShowModify(false)
              break
            case 'update':
              temp = cloneDeep(listBoards).data
              const temp_index = temp.findIndex(
                (oneBoard) => oneBoard._id === board._id,
              )
              temp[temp_index] = board
              setListBoards({
                type: 'UPDATE_BOARD',
                payload: temp,
              })
              setShowModify(false)
              break
            default:
              break
          }
        })
      })
      .catch((error) => {
        console.log('Error creating board for user', error)
        setListBoards({ type: 'BOARDS_FETCH_FAILED' })
      })
  }

  const handleAdd = () => {
    if (board.brand !== '') {
      handleSelectNewItem(board)
    }
    setModifyType('add')
    setShowModify(true)
  }

  const handleSearchInputChange = (event) => {
    setBoard({
      brand: '',
      model: '',
      year: '',
      volume: '',
      active: true,
    })

    const temp_searchValue = event ? event.target.value : ''
    let temp_data = [...listBoards.initialData]
    if (temp_searchValue !== '') {
      temp_data = temp_data.filter((o) =>
        Object.keys(o).some((k) =>
          o[k]
            .toString()
            .toLowerCase()
            .includes(temp_searchValue.toLowerCase()),
        ),
      )
    }
    setListBoards({
      type: 'SEARCH',
      payload: { data: temp_data, searchValue: temp_searchValue },
    })
  }

  const handleEscSearch = () => {
    setBoard({
      brand: '',
      model: '',
      year: '',
      volume: '',
      active: true,
    })
    setListBoards({
      type: 'SEARCH',
      payload: { data: listBoards.initialData, searchValue: '' },
    })
  }

  const handleClickSelectPage = (num_page) => {
    setListBoards({ type: 'NEW_PAGE', payload: parseInt(num_page) })
  }

  const handleBoardChange = (e) => {
    const id = e.target.id
    const value = id !== 'active' ? e.target.value : e.target.checked
    switch (id) {
      case 'brand':
        setOkBoard({ ...okBoard, brandOk: value.length >= 3 })
        setBoard({ ...board, brand: value })
        break
      case 'model':
        setOkBoard({ ...okBoard, modelOk: value.length >= 2 })
        setBoard({ ...board, model: value })
        break
      case 'year':
        setOkBoard({ ...okBoard, yearOk: value >= 1970 && value <= 2100 })
        setBoard({ ...board, year: value })
        break
      case 'volume':
        setOkBoard({
          ...okBoard,
          volumeOk: Number(value) > 0 && Number(value) <= 500,
        })
        setBoard({ ...board, volume: value })
        break
      case 'active':
        setBoard({ ...board, active: value })
        break
      default:
        break
    }
  }

  return (
    <>
      <section className="section" ref={firstDiv}>
        <div className="columns ">
          <div className="column is-6">
            <h1 className="title is-4 has-text-info-dark has-text-weight-semibold">
              {choosenLang.boards}
            </h1>

            <div className="block">
              <BoardList
                list={listBoards}
                handleSelectNewItem={handleSelectNewItem}
                handleRemove={handleRemove}
                handleModify={handleModify}
                handleAdd={handleAdd}
                handleSort={handleSortBoards}
                handleSearchInputChange={handleSearchInputChange}
                handleEscSearch={handleEscSearch}
                buttonsActive={!showModify}
                disabledDemo={user.userName === demoUserName}
                textClass={textClass}
              />
              <PageSelect
                handleClickSelectPage={handleClickSelectPage}
                list={listBoards}
                itemsPerPage={boardsNumberOfItemsPerPage}
                buttonsActive={!showModify}
              />
            </div>
          </div>
          <div className="column is-4">
            {showModify && (
              <div className="box">
                <BoardModify
                  board={board}
                  okBoard={okBoard}
                  handleBoardChange={handleBoardChange}
                  handleCancelModify={handleCancel}
                  handleSave={handleSave}
                  disabledDemo={user.userName === demoUserName}
                />
              </div>
            )}
            {isDeleting && !deleteAllowed && (
              <div className="notification">
                <button
                  className="delete"
                  onClick={handleCloseNotification}
                ></button>
                {board.brand +
                  ' ' +
                  board.model +
                  ' ' +
                  board.volume +
                  ' ' +
                  board.year +
                  choosenLang.deleteAlert}
              </div>
            )}
          </div>
        </div>
        {removeModal.removeModalIsOpen && (
          <>
            <RemoveBoardSailModal
              options={removeModal}
              handleClose={handleCloseRemoveModal}
              handleDoDelete={handleDoDeleteBoard}
            />
          </>
        )}
      </section>
      <Footer />
    </>
  )
}

export default Boards
